import { IUnitFilter } from "@models/training.model";
import { SortDirection } from "../enums/sort-direction.enum";

export const DEFAULT_UNIT_FILTER: IUnitFilter = {
    categories: [],
    search: null,
    sortOrder: SortDirection.ASC
}